import axios from 'axios'
import i18next from 'i18next'
import { showPopBanner } from '../iba-components/PopBanner'
import { CANCEL_REQUEST } from '../v2/constants'
import { store } from '../v2/store'
import { logout } from '../v2/api/commonV2'
import { wait } from '../v2/utils'
import { updateUser } from '../v2/actions/userInfo'
import { clearFilter } from '../v2/actions/filterInfo'
import { clearSimulationFilter } from '../v2/actions/simulationFilterInfo'

axios.defaultSource = axios.CancelToken.source()
let jumpToLogin = false
// Add a request interceptor
axios.interceptors.request.use(
    (config) => {
        config.headers = {
            Pragma: 'no-cache', // fix IE cache issue: https://stackoverflow.com/questions/45912500/reactjs-ie11-not-making-new-http-request-using-cached-data
            ...config.headers
        }
        if (!config.data) config.data = {}

        // 1. config.cancelToken === null:  not need to abort
        // 2. other: auto set cancel token
        if (!config.cancelToken && config.cancelToken !== null) {
            config.cancelToken = axios.defaultSource.token
        }
        return config
    },
    (error) => {
        // Do something with request error
        return Promise.reject(error)
    }
)

// Add a response interceptor
axios.interceptors.response.use(
    (res) => {
        res.data = decodeHtml(res.data)
        return res
    },
    async (err) => {
        // err.config
        const data = decodeHtml(err.response?.data)
        const parseData = data ? JSON.parse(data) : undefined

        console.log(err?.response?.status)
        if (err?.response?.status === 401 && !jumpToLogin) {
            jumpToLogin = true
            // cancel request by message
            axios.defaultSource.cancel()

            // refresh default source
            axios.defaultSource = axios.CancelToken.source()

            window.sessionStorage.setItem('notUpdate', true)
            store.dispatch(updateUser({}))
            window.sessionStorage.setItem('notUpdate', true)
            store.dispatch(clearFilter())
            window.sessionStorage.setItem('notUpdate', true)
            store.dispatch(clearSimulationFilter())

            let errorMessage = ''
            if (parseData?.error_code === 'E001') {
                errorMessage = i18next.t('common.doubleLogin')
            } else {
                errorMessage = parseData?.desc || err.response.statusText
            }

            showPopBanner({
                message: errorMessage,
                status: 'error',
                duration: 5000
            })
            // wait for message end
            await wait(5000)
            const redirect_uri = window.location.origin + '/loginiam'
            const { logout_url } = await logout({ redirect_uri })
            const url = logout_url ? decodeURIComponent(logout_url) : redirect_uri
            window.location.href = url
        }

        if (err?.response?.status === 404) {
            showPopBanner({
                message: '404 NOT FOUND',
                status: 'error',
                duration: 3000
            })
        }

        if (err?.response?.status === 500) {
            !err.config.customError &&
                showPopBanner({
                    message: err.response?.data?.desc || err.response.statusText,
                    status: 'error',
                    duration: 3000
                })
        }

        if (err.message === CANCEL_REQUEST) {
            // cancel request
        }
        return Promise.reject(err)
    }
)

export const postData = (url, data, cfg) => {
    const options = {
        method: 'POST',
        data,
        url,
        ...cfg
    }
    return axios(options).then((res) => {
        return JSON.parse(res.data)
    })
}

export const postOtherThanJSONData = (url, data, cfg) => {
    const options = {
        method: 'POST',
        data,
        url,
        ...cfg
    }
    return axios(options).then((res) => {
        return res
    })
}

export function decodeHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html')
    return doc.documentElement.textContent
}
